<template>
  <div class="p-3" style="font-family: IRANSansX-Regular">
    <div class="row" style="direction: rtl">
      <div class="col-12 col-md-12 order-1 m-md-0 mt-3">
        <input
          type="text"
          v-model="chart_request.title"
          class="form-control chart-input chart-title"
          placeholder="نام"
        />
        <div
          :style="`
                text-align: center;
                display: ${errors.name_error};
                border-radius: 8px;
                line-height: 40px;
                border: 1px solid rgba(255, 0, 51, 0.3);
                font-size: 14px;
                margin-top: 8px;
                color: red;
                text-shadow: rgb(255, 255, 255) 1px 1px;`"
        >
          نام را وارد کنید.
        </div>
      </div>
    </div>
    <div class="w-100 m-3"></div>
    <div class="row justify-content-center" style="direction: ltr">
      <div class="col-12 col-md-7 m-md-0 mb-3 order-1">
        <DatePicker
          @updateDatePickerForm="updateFormDate"
          :limit_under_18y="false"
          :limit_future_range="true"
        ></DatePicker>
        <div
          class="input-group p-2"
          :style="`
                text-align: center;
                border-radius: 8px;;
                border: 1px solid rgba(255, 0, 51, 0.3);
                display: ${errors.date_error};
                direction: rtl;
                font-size: 14px;
                margin-top: 8px;
                color: red;
                text-shadow: rgb(255, 255, 255) 1px 1px;`"
        >
          تاریخ نامعتبر است.
        </div>
      </div>
      <div class="col-12 col-md-5 m-0 order-2">
        <TimePicker @updateTimePickerForm="updateFormTime"></TimePicker>
        <div
          class="input-group p-2"
          :style="`
                text-align: center;
                border-radius: 8px;;
                border: 1px solid rgba(255, 0, 51, 0.3);
                display: ${errors.time_error};
                direction: rtl;
                font-size: 14px;
                margin-top: 8px;
                color: red;
                text-shadow: rgb(255, 255, 255) 1px 1px;`"
        >
          زمان نامعتبر است.
        </div>
      </div>
    </div>

    <div class="w-100 m-3"></div>
    <autocomplete
      :style="`font-size: 16px; text-align: center; border: ${errors.location_error} 1px solid; border-radius: 8px;`"
      aria-label="جستجوی موقعیت جغرافیایی"
      placeholder="شهر محل تولد"
      :search="search"
      :get-result-value="getResultValue"
      @submit="handleSubmit"
      id="location-autocomplete"
    >
    </autocomplete>

    <div class="row justify-content-center" style="direction: ltr" v-if="!auto_location">
      <div class="col-12 col-md-6 m-md-0 order-1">
        <div class="input-group mr-auto mx-auto text-center p-2 location-detail mt-2">
          <div
            style="font-size: 14px; text-align: center; width: 100%; color: #6e6e6e"
            class="mb-2"
          >
            طول جغرافیایی
          </div>
          <div class="input-group">
            <input
              class="form-control"
              style="
                font-size: 12px;
                border: none;
                text-align: center;
                background: transparent;
              "
              type="text"
              value="جهت"
              disabled
            />
            <input
              class="form-control"
              style="
                font-size: 12px;
                border: none;
                text-align: center;
                background: transparent;
              "
              type="text"
              value="درجه"
              disabled
            />
            <input
              class="form-control"
              style="
                font-size: 12px;
                border: none;
                text-align: center;
                background: transparent;
              "
              type="text"
              value="دقیقه"
              disabled
            />
          </div>
          <div class="input-group">
            <div
              style="
                position: relative;
                flex: 1 1 auto;
                width: 1%;
                min-width: 0;
                margin: 5px;
              "
            >
              <div
                style="display: flex; align-items: center; height: 100%; font-size: 12px"
              >
                <div class="h-input-picker-wrapper">
                  <select
                    class="h-input-picker"
                    v-model="chart_request.lon_dir"
                    id="input_lon_dir"
                  >
                    <option value="E">E</option>
                    <option value="W">W</option>
                  </select>
                </div>
              </div>
            </div>

            <div class="h-input-group">
              <div class="h-input-wrapper">
                <input
                  class="h-input"
                  type="number"
                  v-model="input_lon_deg"
                  @keypress="validateLonDeg"
                  id="input_lon_deg"
                  max="180"
                  min="0"
                />
              </div>
            </div>

            <div class="h-input-group">
              <div class="h-input-wrapper">
                <input
                  class="h-input"
                  type="number"
                  v-model="input_lon_min"
                  @keypress="validateLonMin"
                  id="input_lon_min"
                  max="59"
                  min="0"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 col-md-6 m-md-0 order-2">
        <div class="input-group mr-auto mx-auto text-center p-2 location-detail mt-2">
          <div
            style="font-size: 14px; text-align: center; width: 100%; color: #6e6e6e"
            class="mb-2"
          >
            عرض جغرافیایی
          </div>
          <div class="input-group">
            <input
              class="form-control"
              style="
                font-size: 12px;
                border: none;
                text-align: center;
                background: transparent;
              "
              type="text"
              value="جهت"
              disabled
            />
            <input
              class="form-control"
              style="
                font-size: 12px;
                border: none;
                text-align: center;
                background: transparent;
              "
              type="text"
              value="درجه"
              disabled
            />
            <input
              class="form-control"
              style="
                font-size: 12px;
                border: none;
                text-align: center;
                background: transparent;
              "
              type="text"
              value="دقیقه"
            />
          </div>
          <div class="input-group">
            <div
              style="
                position: relative;
                flex: 1 1 auto;
                width: 1%;
                min-width: 0;
                margin: 5px;
              "
            >
              <div
                style="display: flex; align-items: center; height: 100%; font-size: 12px"
              >
                <div class="h-input-picker-wrapper">
                  <select
                    class="h-input-picker"
                    v-model="chart_request.lat_dir"
                    id="input_lat_dir"
                  >
                    <option value="N">N</option>
                    <option value="S">S</option>
                  </select>
                </div>
              </div>
            </div>

            <div class="h-input-group">
              <div class="h-input-wrapper">
                <input
                  class="h-input"
                  type="number"
                  v-model="input_lat_deg"
                  @keypress="validateLatDeg"
                  id="input_lat_deg"
                  max="180"
                  min="0"
                />
              </div>
            </div>

            <div class="h-input-group">
              <div class="h-input-wrapper">
                <input
                  class="h-input"
                  type="number"
                  v-model="input_lat_min"
                  @keypress="validateLatMin"
                  id="input_lat_min"
                  max="59"
                  min="0"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-12 col-md-12 m-md-0 order-3">
        <div class="h-error mt-2 p-2 text-center" v-if="dms_error">
          ورودی طول یا عرض نامعتبر است
        </div>
      </div>
    </div>

    <div style="width: 300px" class="mr-auto mx-auto"></div>

    <!-- <div class="advanced-area" style="direction: ltr" v-if="is_advance_form"> -->
    <div class="advanced-area" style="direction: ltr">
      <div class="row mt-3">
        <div class="col-12 col-md-6 m-md-0 mb-3">
          <DSTSelector @updateFormDSToffset="updateDSToffset"></DSTSelector>
        </div>

        <div class="col-12 col-md-6 m-md-0 mb-3">
          <TimezoneSelector
            :input_disabled="auto_timezone"
            :default_input.sync="chart_request.timezone"
          ></TimezoneSelector>
        </div>
      </div>
    </div>
    <div class="w-100 m-3"></div>

    <div class="row justify-content-center" style="direction: ltr">
      <!-- <div class="col-12 col-md-6 mr-auto mx-auto m-md-0 mb-3 order-1">
        <div class="container mt-2">
          <div class="form-check form-switch" style="font-size: 14px; text-align: center">
            <input
              class="form-check-input"
              type="checkbox"
              role="switch"
              v-model="auto_location"
              id="flexSwitchCheckDefault"
            />
            <label class="form-check-label small" for="flexSwitchCheckDefault"
              >تنظیم بر اساس شهر</label
            >
          </div>
        </div>
      </div> -->
      <div class="col-12 col-md-6 m-md-0 mb-3 order-1">
        <div class="container mt-2">
          <div class="form-check form-switch" style="font-size: 14px; text-align: center">
            <input
              class="form-check-input"
              type="checkbox"
              role="switch"
              v-model="auto_timezone"
              @change="changeAutoTimezone"
              id="flexSwitchCheckDefaultDet"
            />
            <label class="form-check-label small" for="flexSwitchCheckDefaultDet"
              >تنظیم خودکار منطقه زمانی</label
            >
          </div>
        </div>
      </div>
    </div>
    <div class="w-100 m-3"></div>

    <div class="container text-center mb-2">
      <div @click="submitChart()" class="calculate-btn mr-auto mx-auto">
        پرداخت آنلاین و مشاهده تفسیر چارت تولد
      </div>
    </div>

    <Loading :is-loading="isLoading"></Loading>

  </div>
</template>

<script>
import DatePicker from "./DatePicker.vue";
import TimePicker from "./TimePicker.vue";
import Autocomplete from "@trevoreyre/autocomplete-vue";
import ApiService from "../service/api";
import DSTSelector from "./DSTSelector.vue";
import TimezoneSelector from "./TimezoneSelector.vue";

import HelperLib from "./helper";
import Loading from "./Loading.vue";

export default {
  name: "ReportForm",
  components: {
    Loading,
    DatePicker,
    Autocomplete,
    TimezoneSelector,
    DSTSelector,
    TimePicker,

  },
  props: {
    t_year: null,
    t_month: null,
    t_day: null,
    t_hour: null,
    t_min: null,
    t_sec: null,
  },
  data() {
    return {
      auto_location: true,
      auto_timezone: true,
      only_county: false,
      isLoading: false,
      errors: {
        name_error: "none",
        // gender_error: "none",
        time_error: "none",
        date_error: "none",
        location_error: "transparent",
      },

      dms_error: false,
      input_lat_min: "",
      input_lat_deg: "",
      input_lat_min_sign: "",
      input_lat_dir: "",
      input_lon_min: "",
      input_lon_deg: "",
      input_lon_dir: "",
      input_lon_min_sign: "",

      lat_loc_deg_range: this.getRange(0, 90),
      lat_loc_dir: ["N", "S"],
      lat_loc_min_range: this.getRange(0, 60),

      lat_dir_search: null,
      lat_deg_search: null,
      lat_min_search: null,

      lon_loc_deg_range: this.getRange(0, 180),
      lon_loc_dir: ["E", "W"],
      lon_loc_min_range: this.getRange(0, 60),

      lon_dir_search: null,
      lon_deg_search: null,
      lon_min_search: null,

      is_advance_form: false,
      datepicker_column: {
        576: 1, // under 576px, column count is 1
        992: 2, // under 992px, column count is 2
      },
      chart_request: {
        title: "",
        display_loc: '',
        latitude: null,
        longitude: null,
        altitude: null,
        year: null,
        month: null,
        day: null,
        hour: null,
        min: null,
        sec: null,
        timezone: null,
        city: null,
        state: null,
        country: null,
        tz_country: null,
        date_type: null,
        dasha_date_type: null,
        vargas: null,
        nesting: null,
        t_date_type: null,
        dst_min: "0",
        dst_hour: "0",
        lat_deg: null,
        lat_min: null,
        lat_sec: null,
        lat_dir: null,
        lon_deg: null,
        lon_min: null,
        lon_sec: null,
        lon_dir: null,
      },
      chart_result: Object,
    };
  },
  watch: {
    input_lat_min: function (value) {
      // console.log(value);
      if (value.charAt(0) === "-" && value.length > 3) {
        this.input_lat_min = value.substring(1, 3);
      }
      if (value.charAt(0) !== "-" && value.length > 2) {
        this.input_lat_min = value.substring(0, 2);
      }
      const regex = /^0?[0-9]|[1-5][0-9]$/;
      if (!regex.test(value) && value) {
        this.dms_error = true;
      } else {
        this.dms_error = false;
        this.chart_request.lat_min = this.input_lat_min;
      }
    },
    input_lat_deg: function (value) {
      if (value.length > 3) {
        this.input_lat_deg = value.substring(0, 3);
      }
      const regex = /^(?:\d{1,2}|1[0-7]\d|180)$/;
      if (!regex.test(value) && value) {
        this.input_lat_deg = value.substring(0, 3);
        this.dms_error = true;
      } else {
        this.dms_error = false;
        this.chart_request.lat_deg = this.input_lat_deg;
      }
    },

    input_lon_min: function (value) {
      // console.log(value);
      if (value.charAt(0) === "-" && value.length > 3) {
        this.input_lon_min = value.substring(1, 3);
      }
      if (value.charAt(0) !== "-" && value.length > 2) {
        this.input_lon_min = value.substring(0, 2);
      }
      const regex = /^0?[0-9]|[1-5][0-9]$/;
      if (!regex.test(value) && value) {
        this.dms_error = true;
      } else {
        this.dms_error = false;
        this.chart_request.lon_min = this.input_lon_min;
      }
    },
    input_lon_deg: function (value) {
      if (value.length > 3) {
        this.input_lon_deg = value.substring(0, 3);
      }
      const regex = /^(?:\d{1,2}|1[0-7]\d|180)$/;
      if (!regex.test(value) && value) {
        this.input_lon_deg = value.substring(0, 3);
        this.dms_error = true;
      } else {
        this.dms_error = false;
        this.chart_request.lon_deg = this.input_lon_deg;
      }
    },

    // input_lon_dir: function (value) {
    //   console.log(value)
    //   if(value === "N" || value === "S"){
    //     this.input_lon_dir = value
    //     this.chart_request.lon_dir = value
    //   }
    // },
    // input_lat_dir: function (value) {
    //   console.log(value)
    //   if(value === "W" || value === "E"){
    //     this.input_lat_dir = value
    //     this.chart_request.lat_dir = value
    //   }
    // },
  },
  methods: {
    validateLatMin(e) {
      const regex = /^[0-9]$/;
      const newMinValue = this.input_lat_min + e.key;

      if (!regex.test(e.key) && e.key !== "Backspace" && e.key !== "Delete") {
        e.preventDefault();
      } else if (parseInt(newMinValue) > 59 || newMinValue.length > 2) {
        e.preventDefault();
      }
    },
    validateLatDeg(e) {
      const regex = /^[0-9]$/;
      const newDegreeValue = this.input_lat_deg + e.key;

      if (!regex.test(e.key) && e.key !== "Backspace" && e.key !== "Delete") {
        e.preventDefault();
      } else if (parseInt(newDegreeValue) > 90 || newDegreeValue.length > 2) {
        e.preventDefault();
      }
    },
    validateLonMin(e) {
      const regex = /^[0-9]$/;
      const newMinValue = this.input_lon_min + e.key;

      if (!regex.test(e.key) && e.key !== "Backspace" && e.key !== "Delete") {
        e.preventDefault();
      } else if (parseInt(newMinValue) > 59 || newMinValue.length > 2) {
        e.preventDefault();
      }
    },
    validateLonDeg(e) {
      const regex = /^[0-9]$/;
      const newDegreeValue = this.input_lon_deg + e.key;

      if (!regex.test(e.key) && e.key !== "Backspace" && e.key !== "Delete") {
        e.preventDefault();
      } else if (parseInt(newDegreeValue) > 181 || newDegreeValue.length > 3) {
        e.preventDefault();
      }
    },

    changeAutoTimezone() {
      // this.auto_timezone = !this.auto_timezone;
      if (this.auto_timezone == true) {
        this.handlerNearestTimezone();
      }
    },
    getRange(start, end) {
      const result = [];
      for (let i = start; i <= end; i++) {
        result.push(i.toString());
      }
      return result;
    },
    updateFormDate(year, month, day, date_type) {
      this.chart_request.year = year;
      this.chart_request.month = month;
      this.chart_request.day = day;
      this.chart_request.date_type = date_type;
    },
    updateFormTime(hour, min, sec) {
      this.chart_request.hour = hour;
      this.chart_request.min = min;
      this.chart_request.sec = sec;
    },
    updateFormTimezone(tz) {
      // console.log("TEST", tz)
      this.chart_request.timezone = tz;
    },
    updateDSToffset(dst_value) {
      switch (dst_value) {
        case "0":
          this.chart_request.dst_hour = "0";
          this.chart_request.dst_min = "0";
          break;
        case "1":
          this.chart_request.dst_hour = "0";
          this.chart_request.dst_min = "30";
          break;
        case "2":
          this.chart_request.dst_hour = "1";
          this.chart_request.dst_min = "0";
          break;
        case "3":
          this.chart_request.dst_hour = "1";
          this.chart_request.dst_min = "30";
          break;
        case "4":
          this.chart_request.dst_hour = "2";
          this.chart_request.dst_min = "0";
          break;
      }
    },
    validateForm() {
      let result = true;

      this.errors.name_error = this.chart_request.title === "" ? "block" : "none";
      this.errors.time_error = this.chart_request.hour === null ? "block" : "none";
      this.errors.date_error = this.chart_request.year === null ? "block" : "none";
      this.errors.location_error =
        this.chart_request.longitude === null ? "red" : "transparent";

      const requiredFields = [
        this.chart_request.title,
        this.chart_request.hour,
        this.chart_request.year,
        this.chart_request.month,
        this.chart_request.day,
        this.chart_request.longitude,
        // this.chart_request.gender,
      ];

      for (const field of requiredFields) {
        if (field === "" || field === null) {
          result = false;
          break;
        }
      }

      return result;
    },

    resetFormErrors() {},
    showFormErrors() {},
    submitChart() {
      // return this.test_submitChart();
      // console.log(this.auto_location);
      if (this.auto_location == false) {
        this.chart_request.latitude = HelperLib.convertDMSToDegree(
          this.chart_request.lat_deg,
          this.chart_request.lat_min,
          this.chart_request.lat_sec,
          this.chart_request.lat_dir
        );
        this.chart_request.longitude = HelperLib.convertDMSToDegree(
          this.chart_request.lon_deg,
          this.chart_request.lon_min,
          this.chart_request.lon_sec,
          this.chart_request.lon_dir
        );
        if (this.auto_timezone) {
          this.handlerNearestTimezone();
        }
      }
      if (this.validateForm()) {
        this.isLoading = true;
        ApiService.makeReportOrder(this.chart_request).then((response) => {
          // console.log(response);
          this.isLoading = false;
          window.location.replace(response["data"]["checkout_url"]);
        });
      }
    },
    search(input) {
      return new Promise((resolve) => {
        // const url = `https://nominatim.openstreetmap.org/search?format=geojson&limit=5&addressdetails=1&city=${encodeURI(
        //   input,
        // )}`
        // let url = `https://photon.komoot.io/api/?q=${encodeURI(input)}&layer=city`;
        let url = `https://nominatim.openstreetmap.org/search?format=geojson&limit=5&addressdetails=1&city=${encodeURI(
          input
        )}`;

        // console.log(this.only_county);
        if (this.only_county) {
          // url = `https://photon.komoot.io/api/?q=${encodeURI(input)}&layer=country`;
          url = `https://nominatim.openstreetmap.org/search?format=geojson&limit=5&addressdetails=1&country=${encodeURI(
            input
          )}`;
        }
        if (input.length < 3) {
          return resolve([]);
        }
        fetch(url)
          .then((response) => response.json())
          .then((data) => {
            resolve(data.features);
          });
      });
    },
    getResultValue(result) {
      let _c = result["properties"]["address"]["country"]
        ? result["properties"]["address"]["country"]
        : "بدون کشور";
      let _m = result["properties"]["address"]["state"]
        ? result["properties"]["address"]["state"]
        : result["properties"]["address"]["province"]
        ? result["properties"]["address"]["province"]
        : result["properties"]["address"]["region"]
        ? result["properties"]["address"]["region"]
        : "";
      let _ci = result["properties"]["address"]["city"]
        ? result["properties"]["address"]["city"]
        : result["properties"]["address"]["village"]
        ? result["properties"]["address"]["village"]
        : result["properties"]["address"]["hamlet"]
        ? result["properties"]["address"]["hamlet"]
        : "";
      let _vi = result["properties"]["address"]["town"]
        ? result["properties"]["address"]["town"]
        : "";
      // console.log(result);
      // return _c + " , " + _m + " , " + _ci + _vi;
      return result["properties"]['name'] + " - " + _m + " - " + _c;
    },
    handleSubmit(result) {
      // console.log(result);
      this.chart_request.longitude = result["geometry"]["coordinates"][0];
      this.chart_request.latitude = result["geometry"]["coordinates"][1];
      this.chart_request.tz_country = result["properties"]["address"]["country_code"];
      this.chart_request.city = result["properties"]["address"]["city"]
        ? result["properties"]["address"]["city"]
        : result["properties"]["address"]["village"]
        ? result["properties"]["address"]["village"]
        : result["properties"]["address"]["hamlet"];
      this.chart_request.state = result["properties"]["address"]["state"]
        ? result["properties"]["address"]["state"]
        : result["properties"]["address"]["province"]
        ? result["properties"]["address"]["province"]
        : result["properties"]["address"]["region"];
      this.chart_request.display_loc = result["properties"]['display_name']
      this.chart_request.country = result["properties"]["address"]["country"];

      const lon_dms = HelperLib.convertDegreeToDMS(this.chart_request.longitude, true);
      const lat_dms = HelperLib.convertDegreeToDMS(this.chart_request.latitude);

      this.input_lon_deg = lon_dms["deg"];
      this.chart_request.lon_deg = this.input_lon_deg;

      // this.input_lon_min = lon_dms["min"];
      // this.chart_request.lon_min = this.input_lon_min;

      // this.input_lon_dir = lon_dms["dir"];
      this.chart_request.lon_dir = lon_dms["dir"];

      if (lon_dms["min"].toString().charAt(0) === "-") {
        // this.input_lon_min_sign = "-";
        // console.log(lon_dms["min"]);
        this.input_lon_min = lon_dms["min"].toString().substring(1, 3);
      } else {
        // this.input_lon_min_sign = "+";
        this.input_lon_min = lon_dms["min"].toString();
      }
      this.chart_request.lon_min = lon_dms["min"];
      this.chart_request.lon_sec = lon_dms["sec"];
      // this.chart_request.lat_dir = lat_dms["dir"];
      // this.$refs.lat_dir_ref.setSearchData(lat_dms["dir"].toString());

      // this.input_lat_dir = lat_dms["dir"];
      this.chart_request.lat_dir = lat_dms["dir"];

      // this.chart_request.lat_deg = lat_dms["deg"];
      // this.$refs.lat_deg_ref.setSearchData(lat_dms["deg"].toString());

      this.input_lat_deg = lat_dms["deg"];
      this.chart_request.lat_deg = this.input_lat_deg;

      if (lat_dms["min"].toString().charAt(0) === "-") {
        // this.input_lat_min_sign = "-";
        // console.log(lat_dms["min"]);
        this.input_lat_min = lat_dms["min"].toString().substring(1, 3);
      } else {
        // this.input_lat_min_sign = "+";
        this.input_lat_min = lat_dms["min"].toString();
      }

      this.chart_request.lat_min = this.input_lat_min;
      this.chart_request.lat_sec = lon_dms["sec"];

      // this.$refs.lat_min_ref.setSearchData(lat_dms["min"].toString());

      this.handlerNearestTimezone();
    },
    handlerNearestTimezone() {
      let request = {
        latitude: this.chart_request.latitude,
        longitude: this.chart_request.longitude,
        tz_country: this.chart_request.tz_country,
      };

      if (this.chart_request.tz_country == 'ir'){
        this.chart_request.timezone = "+03:30";
      } else {
        HelperLib.showLoading();
        this.isLoading = true;
        ApiService.getNearestTimezone(request).then((response) => {
          this.chart_request.timezone = response["data"][1];
          this.isLoading = false;
          // console.log(response);
          HelperLib.hideLoading();
        });
      }

    },
  },
};
</script>

<style>
.autocomplete-input {
  border: 1px solid #eee;
  border-radius: 8px;
  width: 100%;
  padding: 12px 48px 12px 12px;
  box-sizing: border-box;
  position: relative;
  font-size: 16px;
  line-height: 1.5;
  flex: 1;
  background-color: #eee;
  background-image: url("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjNjY2IiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCI+PGNpcmNsZSBjeD0iMTEiIGN5PSIxMSIgcj0iOCIvPjxwYXRoIGQ9Ik0yMSAyMWwtNC00Ii8+PC9zdmc+");
  background-repeat: no-repeat;
  background-position: calc(100% - 10px);
  background-size: 20px;
  text-align: center;
}

.autocomplete-input:focus,
.autocomplete-input[aria-expanded="true"] {
  border-color: rgba(0, 0, 0, 0.12);
  background-color: #fff;
  outline: none;
  box-shadow: 0 2px 2px rgba(0, 0, 0, 0.16);
}

.autocomplete-input::placeholder {
  font-size: 16px;
}

[data-position="below"] .autocomplete-input[aria-expanded="true"] {
  border-bottom-color: transparent;
  border-radius: 8px 8px 0 0;
}

[data-position="above"] .autocomplete-input[aria-expanded="true"] {
  border-top-color: transparent;
  border-radius: 0 0 8px 8px;
  z-index: 2;
}

.autocomplete[data-loading="true"]:after {
  content: "";
  border: 3px solid rgba(0, 0, 0, 0.12);
  border-right-color: rgba(0, 0, 0, 0.48);
  border-radius: 100%;
  width: 20px;
  height: 20px;
  position: absolute;
  left: 12px;
  top: 50%;
  transform: translateY(-50%);
  animation: rotate 1s linear infinite;
}

.autocomplete-result-list {
  font-size: 16px;
  margin: 0;
  border: 1px solid rgba(0, 0, 0, 0.12);
  padding: 0;
  box-sizing: border-box;
  max-height: 296px;
  overflow-y: auto;
  background: #fff;
  list-style: none;
  box-shadow: 0 2px 2px rgba(0, 0, 0, 0.16);
}

[data-position="below"] .autocomplete-result-list {
  margin-top: -1px;
  border-top-color: transparent;
  border-radius: 0 0 8px 8px;
  padding-bottom: 8px;
}

[data-position="above"] .autocomplete-result-list {
  margin-bottom: -1px;
  border-bottom-color: transparent;
  border-radius: 8px 8px 0 0;
  padding-top: 8px;
}

.autocomplete-result {
  font-size: 16px;
  cursor: default;
  padding: 12px 48px 12px 12px;
  background-image: url("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjY2NjIiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCI+PGNpcmNsZSBjeD0iMTEiIGN5PSIxMSIgcj0iOCIvPjxwYXRoIGQ9Ik0yMSAyMWwtNC00Ii8+PC9zdmc+");
  background-repeat: no-repeat;
  background-position: calc(100% - 10px);
}

.autocomplete-result:hover,
.autocomplete-result[aria-selected="true"] {
  background-color: rgba(0, 0, 0, 0.06);
}

@keyframes rotate {
  0% {
    transform: translateY(-50%) rotate(0deg);
  }
  to {
    transform: translateY(-50%) rotate(359deg);
  }
}
.h-input-group {
  position: relative;
  flex: 1 1 auto;
  width: 1%;
  min-width: 0;
  margin: 5px;
  outline: none;
}
.h-input-wrapper {
  font-weight: 400;
  font-size: 1rem;
  line-height: 1.5;
  align-items: center;
  display: flex;
  flex: 1 1 auto;
  flex-wrap: wrap;
  width: 100%;
  color: #495057;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  height: 100%;
  box-sizing: border-box;
  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out,
    box-shadow 0.15s ease-in-out;
}
.h-input {
  font-size: 1rem;
  background-size: 25px 25px;
  background-position: right 10px center;
  background-repeat: no-repeat;
  color: #495057 !important;
  background-color: transparent;
  border-style: none;
  pointer-events: auto;
  flex: 1 1;
  margin-top: 0;
  min-width: 0;
  position: relative;
  line-height: 20px;
  max-width: 100%;
  width: 100%;
  height: calc(1.5em + 0.75rem);
  padding: 0.375rem 0.75rem;
  border-radius: 0.25rem;
  text-align: center;
}

.h-input:focus {
  border-color: #80bdff;
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgb(128 189 255 / 50%);
  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out,
    box-shadow 0.15s ease-in-out;
}
.h-input-picker {
  font-size: 1rem;
  background-size: 25px 25px;
  background-position: right 10px center;
  background-repeat: no-repeat;
  color: #495057 !important;
  background-color: white;
  border: 1px solid #ccc;
  pointer-events: auto;
  flex: 1 1;
  margin-top: 0;
  min-width: 0;
  padding: 7px;
  border-radius: 5px;
  position: relative;
  line-height: 20px;
  max-width: 100%;
  width: 100%;
  text-align: center;
}

.h-input-picker-wrapper {
  align-items: center;
  display: flex;
  flex: 1 1 auto;
  flex-wrap: wrap;
  width: 100%;
  color: #495057;
}

.h-error {
  width: 100%;
  font-size: 12px;
  color: red;
}
</style>

<style scoped>
.chart-input {
  border: 1px solid #eee;
  border-radius: 8px;
  width: 100%;
  padding: 12px 48px 12px 12px;
  box-sizing: border-box;
  position: relative;
  font-size: 16px;
  line-height: 1.5;
  flex: 1;
  text-align: center;
  background-color: #eee;
  background-repeat: no-repeat;
  background-position: right;
  margin: 0;
}

.chart-input:focus,
.chart-input[aria-expanded="true"] {
  border-color: rgba(0, 0, 0, 0.12);
  background-color: #fff;
  outline: none;
  box-shadow: 0 2px 2px rgba(0, 0, 0, 0.16);
}

.chart-datepicker {
  border: none;
  padding: none;
  margin: none;
  width: 100%;
}

.chart-datepicker > input {
  background: #eee;
}

.chart-datetime {
  background-image: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiIgZmlsbD0iY3VycmVudENvbG9yIiBjbGFzcz0iYmkgYmktY2FsZW5kYXItY2hlY2siIHZpZXdCb3g9IjAgMCAxNiAxNiI+CiAgPHBhdGggZD0iTTEwLjg1NCA3LjE0NmEuNS41IDAgMCAxIDAgLjcwOGwtMyAzYS41LjUgMCAwIDEtLjcwOCAwbC0xLjUtMS41YS41LjUgMCAxIDEgLjcwOC0uNzA4TDcuNSA5Ljc5M2wyLjY0Ni0yLjY0N2EuNS41IDAgMCAxIC43MDggMHoiLz4KICA8cGF0aCBkPSJNMy41IDBhLjUuNSAwIDAgMSAuNS41VjFoOFYuNWEuNS41IDAgMCAxIDEgMFYxaDFhMiAyIDAgMCAxIDIgMnYxMWEyIDIgMCAwIDEtMiAySDJhMiAyIDAgMCAxLTItMlYzYTIgMiAwIDAgMSAyLTJoMVYuNWEuNS41IDAgMCAxIC41LS41ek0xIDR2MTBhMSAxIDAgMCAwIDEgMWgxMmExIDEgMCAwIDAgMS0xVjRIMXoiLz4KPC9zdmc+);
  background-position: calc(100% - 10px);
  text-align: center;
}

.chart-title {
  background-image: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiIgZmlsbD0iY3VycmVudENvbG9yIiBjbGFzcz0iYmkgYmktaW5wdXQtY3Vyc29yLXRleHQiIHZpZXdCb3g9IjAgMCAxNiAxNiI+CiAgPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBkPSJNNSAyYS41LjUgMCAwIDEgLjUtLjVjLjg2MiAwIDEuNTczLjI4NyAyLjA2LjU2Ni4xNzQuMDk5LjMyMS4xOTguNDQuMjg2LjExOS0uMDg4LjI2Ni0uMTg3LjQ0LS4yODZBNC4xNjUgNC4xNjUgMCAwIDEgMTAuNSAxLjVhLjUuNSAwIDAgMSAwIDFjLS42MzggMC0xLjE3Ny4yMTMtMS41NjQuNDM0YTMuNDkgMy40OSAwIDAgMC0uNDM2LjI5NFY3LjVIOWEuNS41IDAgMCAxIDAgMWgtLjV2NC4yNzJjLjEuMDguMjQ4LjE4Ny40MzYuMjk0LjM4Ny4yMjEuOTI2LjQzNCAxLjU2NC40MzRhLjUuNSAwIDAgMSAwIDEgNC4xNjUgNC4xNjUgMCAwIDEtMi4wNi0uNTY2QTQuNTYxIDQuNTYxIDAgMCAxIDggMTMuNjVhNC41NjEgNC41NjEgMCAwIDEtLjQ0LjI4NSA0LjE2NSA0LjE2NSAwIDAgMS0yLjA2LjU2Ni41LjUgMCAwIDEgMC0xYy42MzggMCAxLjE3Ny0uMjEzIDEuNTY0LS40MzQuMTg4LS4xMDcuMzM1LS4yMTQuNDM2LS4yOTRWOC41SDdhLjUuNSAwIDAgMSAwLTFoLjVWMy4yMjhhMy40OSAzLjQ5IDAgMCAwLS40MzYtLjI5NEEzLjE2NiAzLjE2NiAwIDAgMCA1LjUgMi41LjUuNSAwIDAgMSA1IDJ6Ii8+CiAgPHBhdGggZD0iTTEwIDVoNGExIDEgMCAwIDEgMSAxdjRhMSAxIDAgMCAxLTEgMWgtNHYxaDRhMiAyIDAgMCAwIDItMlY2YTIgMiAwIDAgMC0yLTJoLTR2MXpNNiA1VjRIMmEyIDIgMCAwIDAtMiAydjRhMiAyIDAgMCAwIDIgMmg0di0xSDJhMSAxIDAgMCAxLTEtMVY2YTEgMSAwIDAgMSAxLTFoNHoiLz4KPC9zdmc+);
  background-position: calc(100% - 10px);
  text-align: center;
  background-size: 20px;
  height: 55px;
}

.chart-form {
  background: #fff;
  border-radius: 8px;
  border: 1px solid #ccc;
}

.save-btn {
  cursor: pointer;
  border-radius: 8px;
  padding: 8px;
  padding-right: 20px;
  padding-left: 20px;
  width: fit-content;
  color: #fff;
  border: 1px #ccc solid;
  border-color: rgba(0, 0, 0, 0.12);
  background-color: #339966;
  outline: none;
  font-size: 16px;
  box-shadow: 0 2px 2px rgba(0, 0, 0, 0.16);
  background: no-repeat
    url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 448 512'%3E%3C!--! Font Awesome Free 6.1.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License) Copyright 2022 Fonticons, Inc. --%3E%3Cpath d='M433.1 129.1l-83.9-83.9C342.3 38.32 327.1 32 316.1 32H64C28.65 32 0 60.65 0 96v320c0 35.35 28.65 64 64 64h320c35.35 0 64-28.65 64-64V163.9C448 152.9 441.7 137.7 433.1 129.1zM224 416c-35.34 0-64-28.66-64-64s28.66-64 64-64s64 28.66 64 64S259.3 416 224 416zM320 208C320 216.8 312.8 224 304 224h-224C71.16 224 64 216.8 64 208v-96C64 103.2 71.16 96 80 96h224C312.8 96 320 103.2 320 112V208z'/%3E%3C/svg%3E");
}

.calculate-btn {
  cursor: pointer;
  border-radius: 8px;
  padding: 8px;
  padding-right: 20px;
  padding-left: 20px;
  width: fit-content;
  color: #fff;
  border: 1px #ccc solid;
  border-color: rgba(0, 0, 0, 0.12);
  background-color: #339966;
  outline: none;
  font-size: 16px;
  box-shadow: 0 2px 2px rgba(0, 0, 0, 0.16);
}

.calculate-btn:hover {
  transition: all 1s;
  box-shadow: 0 2px 2px rgba(0, 0, 0, 0.5);
}

.gender-input {
  background-image: url(data:image/svg+xml;base64,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);
}

.gender-box {
  direction: rtl;
  border: none;
  border-radius: 8px;
  background-color: #eee;
  width: 100%;
  font-size: 16px;
  background-repeat: no-repeat;
  background-size: 22px;
  background-position-x: calc(100% - 10px);
  padding: 12px 48px 12px 12px;
  text-align: center;
  height: 55px;
  margin: 0px;
}

.input-wrapper {
  position: relative;
  flex: 1 1 auto;
  width: 1%;
  min-width: 0;
  margin: 5px;
}

.location-detail {
  text-align: center;
  border: none;
  border-radius: 8px;
  background-color: #eee;
  font-size: 16px;
  text-align: center;
  margin: 0px;
  height: auto;
}
</style>
